
<div class="login-section">
    <h2 mat-dialog-title class="text-center">Change Password</h2>

    <!-- <div class="login-form"> -->
        <!-- <h4 class="text-center">Change Password</h4> -->
        <form [formGroup]="form">
            <mat-dialog-content class="mat-typography">

            <p>This is your first login, Please create your new password</p>
        <div class="row">
            <div class="col-md-12">
                <mat-form-field class="example-form-field full-width" appearance="outline">
                    <mat-label>Old Password</mat-label>
                    <input matInput type="password" maxlength="25" formControlName="oldPassword" autocomplete="off">
                            <mat-error *ngIf="errorHandling('oldPassword', 'required')">
                                Old password is required
                            </mat-error>
                </mat-form-field>
            </div>
            <div class="col-md-12">
                <mat-form-field class="example-form-field full-width" appearance="outline">
                    <mat-label>New Password</mat-label>
                    <input matInput type="password" maxlength="25" formControlName="newPassword"
                                (keyup)="passwordstrength()" [errorStateMatcher]="matcher" autocomplete="off">
                            <mat-error *ngIf="errorHandling('newPassword', 'required')">
                                New password is required
                            </mat-error>
                            <mat-error *ngIf="errorHandling('newPassword', 'isPassword')">
                                Minimum six characters, at least one uppercase, one lowercase, one number and
                                one
                                special character
                            </mat-error>
                            <mat-hint *ngIf="strengthMsg" [ngStyle]={color:msgColor}>{{strengthMsg}}</mat-hint>
                </mat-form-field>
            </div>
            <div class="col-md-12">
                <mat-form-field class="example-form-field full-width" appearance="outline">
                    <mat-label>Confirm Password</mat-label>
                    <input matInput type="password" maxlength="25" formControlName="confirmPassword"
                    [errorStateMatcher]="matcher" autocomplete="off">
                <mat-error *ngIf="errorHandling('confirmPassword', 'required')">
                    Confirm Password is required
                </mat-error>
                <mat-error *ngIf="errorHandling('confirmPassword','NoPassswordMatch')">
                    Password does not match
                </mat-error>
                </mat-form-field>
            </div>
            <!-- <div class="col-md-12 mt-2">
                <button mat-raised-button color="primary" type="submit" class="full-width" (click)="submit()"> Submit </button>
            </div> -->
        </div>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <!-- <button mat-button mat-dialog-close>Cancel</button> -->
            <button mat-raised-button color="primary" (click)="submit()"> Submit</button>
          </mat-dialog-actions>
        </form>
    <!-- </div> -->
</div>